<template>
    <div class="banner">
        <swiper :options="swiperOptiona" ref="mySwipers" class="swiper"  v-if="bList.length>0" >
            <swiper-slide class="item" v-for="(item,index) in bList" :key="index">
                <img :src="`http://www.uni-sec.com/${item.picurl}`" alt="">
                <div class="text">
                    <p>{{item.title}}</p>
                    <!-- <p>{{item.description}}</p> -->
                </div>
            </swiper-slide>
        </swiper>
        <div class="allImgs">
         <div class="animated fadeInUp">
             <img src="../assets/ycb/b1.png" alt="">
         </div>
            <div class="animated fadeInUp" style="animation-delay: 0.4s">
                <img src="../assets/ycb/b2.png" alt="">
            </div>
            <div class="animated fadeInUp" style="animation-delay: 0.5s">
                <img src="../assets/ycb/b3.png" alt="">
            </div>
            <div class="animated fadeInUp" style="animation-delay: 0.8s">
                <img src="../assets/ycb/b4.png" alt="">
            </div>
        </div>
        <div class="btn">
            <button class="cta-btn">
                <svg  viewBox="0 0 89 89" class="border">
                    <path  d="M87.5,44.5a43,43,0,1,1-43-43A43,43,0,0,1,87.5,44.5Z"></path>
                </svg>
                <svg  viewBox="0 0 89 89" class="outline">
                    <path  d="M44.5,1.5a43,43,0,1,0,.77,0Z"></path>
                </svg>
            </button>
            <img src="../assets/ycb/arrow.png" alt="">
        </div>

    </div>
</template>

<script>
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    import { getHomeInfo} from '../util/lang'
    import '../common/jquery-1.11.3.min'
    export default {
        name: "banner",
        data(){
            let _this=this
            return{
                swiperOptiona:{
                    notNextTick: true,
                    loop: true,
                    effect: 'fade',
                    init: false,
                    autoplay:{
                        disableOnInteraction: false,
                        delay: 6000
                    },
                },
            }
        },
        props:[
            'bList'
        ],
        components: {
            swiper,
            swiperSlide,
        },
        mounted(){
            setTimeout(()=>{
                this.$refs.mySwipers.swiper.init()
            },1000)
        },
        methods:{
            gotoAbout(){
                window.open('/about.html','_blank')
            }
        }
    }
</script>

<style lang="scss" scoped>
    .banner{
        width:100%;
        height: calc(100vh - 95px);
        padding-top: 95px;
        position: relative;
        .swiper{
            height:100%;
            .item{
                position: relative;
                overflow: hidden;
                img{
                    width:100%;
                    height:100%;
                    object-fit: cover;
                    display: block;
                    z-index: 1;
                    cursor: pointer;
                    transform: scale(1);
                    transition: all 5s;
                }
                .text{
                    z-index: 10;
                    position: absolute;
                    left: 14%;
                    top:60%;
                    width:80%;
                    p{
                        color:white;
                    }
                    p:nth-child(1){
                        font-size: 35px;
                        font-family: "itbook";
                        text-transform: uppercase;
                        opacity: 0;
                        transform: translateY(-100%) rotateX(150deg);
                        transition: all 1s;
                    }
                    p:nth-child(2){
                        font-family: "it";
                        font-size: 20px;
                        margin-top: 20px;
                        opacity: 0;
                        transition: all 2s;
                        transition-delay: 1s;
                        transform: translateY(-100%) rotate(-60deg);
                    }
                }
            }
            .swiper-slide-active{
                img{
                    transform: scale(1.05);
                }
                .text{
                    p:nth-child(1),   p:nth-child(2){
                        opacity: 1;
                        transform: translateY(0) rotate(0);
                    }
                }
            }
        }
        .btn{
            position: absolute;
            top:45%;
            left: 14%;
            width: 44px;
            height: 44px;
            .cta-btn{
                position: absolute;
                bottom:0;
                left: 0;
                width: 100%;
                height:100%;
                border-radius: 50%;
                background-color: transparent;
                cursor: pointer;
                svg{
                    position: absolute;
                    top: 0;
                    left: 0;
                    overflow: hidden;
                }
                .border{
                    stroke-dasharray: 0;
                    stroke-dashoffset: 0;
                    stroke-width: 2px;
                    path{
                        fill: none;
                        stroke: hsla(0,0%,100%,.3);
                        stroke-miterlimit: 10;
                    }
                }
                .outline{
                    z-index: 1;
                    path{
                        fill: none;
                        stroke-miterlimit: 10;
                        stroke: #fff;
                        stroke-dasharray: 300;
                        /*stroke-dashoffset: 300;*/
                        stroke-width: 2px;
                        animation: run 5s infinite linear;
                    }
                }
                @keyframes run {
                    0%{
                        stroke-dashoffset: -300;
                    }
                    50%{
                        stroke-dashoffset: -150;
                    }
                    100%{
                        stroke-dashoffset: 0;
                    }
                    50%{
                        stroke-dashoffset: 150;
                    }
                    0%{
                        stroke-dashoffset: 300;
                    }
                }
            }
            img{
                position: absolute;
                left:46%;
                top:25%;
                z-index: 10;
                animation: show 1s infinite linear;
                height:15px;
                object-fit: contain;
                width:2px;
            }
            @keyframes show {
              0%{
                 transform: translateY(0);
                  opacity: .8;
              }
                50%{
                    transform: translateY(10px);
                    opacity: 0.3;
                }
                100%{
                    transform: translateY(0);
                    opacity: .8;
                }
            }
        }
        .allImgs{
            position: absolute;
            bottom:10%;
            width:80%;
            left:10%;
            display: flex;
            flex-direction: row;
            align-items: center;
            z-index: 100;
            div{
                width:48px;
                height:49px;
                border:1px solid rgba(117,114,110,1);
                border-radius:50%;
                cursor: pointer;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                margin-left: 5%;
                img{
                    transition: all 600ms;
                }
                &:hover{
                    img{
                        transform:rotateY(360deg);
                    }
                }
            }
        }
        @media screen and (max-width: 1000px){
            .swiper{
              .item{
                  img{
                      height:500px;
                  }
                  .text{
                      left:10%;
                      p:nth-child(1){
                          font-size: 18px;
                      }
                      p:nth-child(2){
                          font-size: 16px;
                      }
                  }
              }
            }
        }
    }
</style>
<style scoped>
    .banner .swiper-pagination {
        bottom: 10%;
        width: 100%;
        left:0;
        display: flex;
        flex-direction: row;
        justify-content: center;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet {
        position: relative;
        width: 80px;
        height: 1px;
        opacity: 0.6;
        margin: 0 15px;
        background-color: rgba(255,255,255,.2);
        border-radius: 0;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet:focus{
        outline: none;
    }
    .banner .swiper-pagination>>>.swiper-pagination-bullet i{
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 100%;
        background-color: #fff;
        opacity:1;
    }
</style>
